module.exports = [{
      plugin: require('/opt/build/repo/node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-5PJMW99","includeInDevelopment":false},
    },{
      plugin: require('/opt/build/repo/skookum-website/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
